import { getDocs, collection } from "firebase/firestore";
import { firestore } from "../../backend/firebaseconfig";

/**
 * Asynchronously retrieves all adviser documents from the Firestore collection.
 *
 * Fetches all documents from the "Authorized Members/Advisers/Data" collection path,
 * and returns an array of adviser objects, each containing the document ID as `userId`
 * and all other adviser data fields (such as tradingName, primaryColor, etc.).
 *
 * @async
 * @function
 * @returns {Promise<Array<Object>>} A promise that resolves to an array of adviser objects.
 * Each object includes a `userId` property and other adviser data fields.
 *
 * @throws {FirebaseError} If there is an error fetching documents from Firestore.
 */
const getAllAdvisers = async () => {
  const advisersSnapshot = await getDocs(
    collection(firestore, "Authorized Members", "Advisers", "Data")
  );

  const advisers = advisersSnapshot.docs.map((doc) => ({
    userId: doc.id,
    ...doc.data(), // includes tradingName, primaryColor, etc.
  }));

  return advisers;
};

export default getAllAdvisers;
